// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-thumbnail__pVNkyA_4{box-sizing:border-box;display:flex;flex-direction:column;height:100%;overflow:hidden;padding:8px 8px 0 8px}.dashboard-grid__SJpTR_Pf{box-sizing:border-box;display:grid;grid-auto-rows:1fr;grid-column-gap:4px;grid-row-gap:4px;grid-template-columns:repeat(12,1fr)}.dashboard-card__OpXRsULs{display:flex;height:44px;min-height:0}.dashboard-card__OpXRsULs.size-l__Xq1XnIb7{height:116px}.dashboard-card-bookmark-image__U56SjWO1{border-radius:4px;height:100%;object-fit:cover;width:100%}.dashboard-card-bookmark-image__U56SjWO1.is-media-card__bcTD_1JI{object-fit:contain}.text-card__NABV32o7{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardThumbnail": "dashboard-thumbnail__pVNkyA_4",
	"dashboardGrid": "dashboard-grid__SJpTR_Pf",
	"dashboardCard": "dashboard-card__OpXRsULs",
	"sizeL": "size-l__Xq1XnIb7",
	"dashboardCardBookmarkImage": "dashboard-card-bookmark-image__U56SjWO1",
	"isMediaCard": "is-media-card__bcTD_1JI",
	"textCard": "text-card__NABV32o7"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
